/* eslint-disable no-param-reassign */
import { useState } from 'react';
import _inRange from 'lodash/inRange';
import {
  resetSyle,
  errorStyle,
  borderStyle,
} from '../../utils/constants';
import { containsSpecialChars } from '../../utils/inputValidation';

const useFieldVerification = () => {
  const [roomError, setShowRoomError] = useState(false);
  const [roomErrorText, setRoomErrorText] = useState('This field is required');
  const [lengthError, setShowLengthError] = useState(false);
  const [lengthErrorText, setLengthErrorText] = useState('This field is required');
  const [widthError, setShowWidthError] = useState(false);
  const [widthErrorText, setWidthErrorText] = useState('This field is required');
  const [styleHelper, setShowStyleHelper] = useState(true);

  const resetFields = (room, length, width) => {
    room.value = '';
    length.value = '';
    width.value = '';
    room.style.border = resetSyle;
    length.style.border = resetSyle;
    width.style.border = resetSyle;
    room.style.borderRadius = borderStyle;
    length.style.borderRadius = borderStyle;
    width.style.borderRadius = borderStyle;

    setShowRoomError(false);
    setShowLengthError(false);
    setShowWidthError(false);
    setShowStyleHelper(true);
  };

  const highlightFieldError = (el, errorText) => {
    el.style.borderBottom = '1px solid #D81118';
    el.style.borderTop = errorStyle;
    el.style.borderLeft = errorStyle;
    el.style.borderRight = errorStyle;
    el.style.borderRadius = borderStyle;
    el.style.borderRadius = borderStyle;
    el.style.borderRadius = borderStyle;
    setShowStyleHelper(false);
  };

  const resetFieldError = (el) => {
    el.style.border = resetSyle;
  };

  const validateRoomName = (element, name) => {
    if (name === '') {
      setShowRoomError(true);
      setRoomErrorText('This field is required');
      highlightFieldError(element);
    } else if (containsSpecialChars(name)) {
      setShowRoomError(true);
      setRoomErrorText('Special characters are prohibited');
      highlightFieldError(element);
    } else {
      setShowRoomError(false);
      resetFieldError(element);
    }
  };

  const validateRoomLength = (element, length) => {
    if (length === '') {
      setShowLengthError(true);
      setLengthErrorText('This field is required');
      highlightFieldError(element, lengthErrorText);
    } else if (_inRange(length, 1, 100)) {
      setShowLengthError(false);
      resetFieldError(element);
    } else {
      setShowLengthError(true);
      setLengthErrorText('Length must be 1 - 99.99');
      // measureRef.current.room_length.errorText = lengthErrorText;
      highlightFieldError(element, lengthErrorText);
    }
  };

  const validateRoomWidth = (element, width) => {
    if (width === '') {
      setShowWidthError(true);
      setWidthErrorText('This field is required');
      highlightFieldError(element, widthErrorText);
    } else if (_inRange(width, 1, 100)) {
      setShowWidthError(false);
      resetFieldError(element);
    } else {
      setShowWidthError(true);
      setWidthErrorText('Width must be 1 - 99.99');
      //  measureRef.current.room_width.errorText = widthErrorText;
      highlightFieldError(element, widthErrorText);
    }
  };

  const validField = (field, roomName, roomLength, roomWidth) => {
    if (field === roomName) {
      const { value } = roomName;
      validateRoomName(roomName, value);
    }

    if (field === roomLength) {
      const { value } = roomLength;
      validateRoomLength(roomLength, value);
    }

    if (field === roomWidth) {
      const { value } = roomWidth;
      validateRoomWidth(roomWidth, value);
    }
  };

  return {
    roomError,
    roomErrorText,
    lengthError,
    lengthErrorText,
    widthError,
    widthErrorText,
    styleHelper,
    validField,
    resetFields,
  };
};

export default useFieldVerification;
